import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { SerializationExceptioneqrdve3ts2n9 as SerializationException } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  ClassCastException1atiay3nqgbd as ClassCastException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { AbstractDecoder35guh02ubh2hm as AbstractDecoder } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/encoding/AbstractDecoder.mjs';
import { NotImplementedErrorfzlkpv14xxr8 as NotImplementedError } from '../../../../../kotlin-kotlin-stdlib/kotlin/Standard.mjs';
import {
  LIST_getInstance2vniy0f7mmb29 as LIST_getInstance,
  MAP_getInstance3e78m6vf98i66 as MAP_getInstance,
  CLASS_getInstance3jy3ydw5832xx as CLASS_getInstance,
  OBJECT_getInstancerq52wx6ymebx as OBJECT_getInstance,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialKinds.mjs';
import { equals2au1ep9vhcato as equals } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { KtList3hktaavzmj137 as KtList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { AbstractEncoder2gxtu3xmy3f8j as AbstractEncoder } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/encoding/AbstractEncoder.mjs';
import { lastOrNull1aq5oz189qoe1 as lastOrNull } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { get_lastIndex1yw0x4k50k51w as get_lastIndex } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { removeLastOrNull3odnlbetbttd4 as removeLastOrNull } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/MutableCollections.mjs';
import { EmptySerializersModule991ju6pz9b79 as EmptySerializersModule } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/modules/SerializersModuleBuilders.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_empty() {
  _init_properties_kxSerializationFieldAccess_kt__gdcurf();
  return empty;
}
var empty;
function set(_this__u8e3s4, instance, index, childSerializer, value, module_0) {
  module_0 = module_0 === VOID ? get_empty() : module_0;
  _init_properties_kxSerializationFieldAccess_kt__gdcurf();
  if (_this__u8e3s4.get_descriptor_wjt6a0_k$().get_isInline_usk17w_k$())
    return _this__u8e3s4.deserialize_sy6x50_k$(new (MinDecoder())(module_0, value));
  var e = MinEncoder().new_com_lightningkite_services_database_MinEncoder_m6hic_k$(module_0);
  _this__u8e3s4.serialize_5ase3y_k$(e, instance);
  var tmp = e.output_1;
  var eo = tmp instanceof ArrayList() ? tmp : THROW_CCE();
  eo.set_82063s_k$(index, value);
  var d = new (MinDecoder())(module_0, e.output_1);
  return _this__u8e3s4.deserialize_sy6x50_k$(d);
}
function get(_this__u8e3s4, instance, index, childSerializer, module_0) {
  module_0 = module_0 === VOID ? get_empty() : module_0;
  _init_properties_kxSerializationFieldAccess_kt__gdcurf();
  var e = MinEncoderSI().new_com_lightningkite_services_database_MinEncoderSI_jmsse4_k$(module_0, index, _this__u8e3s4.get_descriptor_wjt6a0_k$().get_isInline_usk17w_k$());
  _this__u8e3s4.serialize_5ase3y_k$(e, instance);
  var tmp;
  try {
    tmp = e.output_1;
  } catch ($p) {
    var tmp_0;
    if ($p instanceof ClassCastException()) {
      var c = $p;
      throw SerializationException().new_kotlinx_serialization_SerializationException_pjmzgo_k$('KSerializer.get failed to cast the encoded value. Something has gone terribly wrong. Could not coerce ' + toString(e.output_1) + ' into type ' + childSerializer.get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$() + '.', c);
    } else {
      throw $p;
    }
  }
  return tmp;
}
var MinDecoderClass;
function MinDecoder() {
  if (MinDecoderClass === VOID) {
    class $ extends AbstractDecoder() {
      constructor(serializersModule, item) {
        super();
        this.serializersModule_1 = serializersModule;
        this.item_1 = item;
      }
      get_serializersModule_piitvg_k$() {
        return this.serializersModule_1;
      }
      decodeNotNullMark_us4ba1_k$() {
        return !(this.item_1 == null);
      }
      decodeValue_jl9esj_k$() {
        return ensureNotNull(this.item_1);
      }
      decodeSerializableValue_xpnpad_k$(deserializer) {
        return this.decodeValue_jl9esj_k$();
      }
      decodeElementIndex_bstkhp_k$(descriptor) {
        throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$('Use MinDecoderB');
      }
      beginStructure_yljocp_k$(descriptor) {
        var tmp0_subject = descriptor.get_kind_wop7ml_k$();
        var tmp;
        if (equals(tmp0_subject, CLASS_getInstance()) || equals(tmp0_subject, OBJECT_getInstance())) {
          var tmp_0 = this.item_1;
          tmp = new (MinDecoderB())(this.serializersModule_1, (!(tmp_0 == null) ? isInterface(tmp_0, KtList()) : false) ? tmp_0 : THROW_CCE());
        } else if (equals(tmp0_subject, MAP_getInstance())) {
          tmp = this;
        } else if (equals(tmp0_subject, LIST_getInstance())) {
          tmp = this;
        } else {
          // Inline function 'kotlin.TODO' call
          throw NotImplementedError().new_kotlin_NotImplementedError_8rzvsv_k$();
        }
        return tmp;
      }
    }
    initMetadataForClass($, 'MinDecoder');
    MinDecoderClass = $;
  }
  return MinDecoderClass;
}
var MinEncoderClass;
function MinEncoder() {
  if (MinEncoderClass === VOID) {
    class $ extends AbstractEncoder() {
      constructor(serializersModule) {
        return new.target.new_com_lightningkite_services_database_MinEncoder_m6hic_k$(serializersModule);
      }
      static new_com_lightningkite_services_database_MinEncoder_m6hic_k$(serializersModule) {
        var $this = this.new_kotlinx_serialization_encoding_AbstractEncoder_2d7vxe_k$();
        $this.serializersModule_1 = serializersModule;
        $this.output_1 = null;
        $this.stack_1 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(4);
        return $this;
      }
      get_serializersModule_piitvg_k$() {
        return this.serializersModule_1;
      }
      encodeValue_g68i1f_k$(value) {
        var tmp0_safe_receiver = lastOrNull(this.stack_1);
        if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.add_utx5q5_k$(value)) == null) {
          // Inline function 'kotlin.run' call
          this.output_1 = value;
        }
      }
      encodeSerializableValue_3uuzip_k$(serializer, value) {
        if (value == null) {
          this.encodeNull_ejiosz_k$();
        } else {
          this.encodeValue_g68i1f_k$(!(value == null) ? value : THROW_CCE());
        }
      }
      beginStructure_yljocp_k$(descriptor) {
        this.stack_1.add_utx5q5_k$(ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(descriptor.get_elementsCount_288r0x_k$()));
        return this;
      }
      endStructure_1xqz0n_k$(descriptor) {
        this.encodeValue_g68i1f_k$(this.stack_1.removeAt_6niowx_k$(get_lastIndex(this.stack_1)));
      }
      encodeNull_ejiosz_k$() {
        var tmp0_safe_receiver = lastOrNull(this.stack_1);
        if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.add_utx5q5_k$(null)) == null) {
          // Inline function 'kotlin.run' call
          this.output_1 = null;
        }
      }
    }
    initMetadataForClass($, 'MinEncoder');
    MinEncoderClass = $;
  }
  return MinEncoderClass;
}
var MinEncoderSIClass;
function MinEncoderSI() {
  if (MinEncoderSIClass === VOID) {
    class $ extends AbstractEncoder() {
      constructor(serializersModule, resultIndex, inline) {
        return new.target.new_com_lightningkite_services_database_MinEncoderSI_jmsse4_k$(serializersModule, resultIndex, inline);
      }
      static new_com_lightningkite_services_database_MinEncoderSI_jmsse4_k$(serializersModule, resultIndex, inline) {
        inline = inline === VOID ? false : inline;
        var $this = this.new_kotlinx_serialization_encoding_AbstractEncoder_2d7vxe_k$();
        $this.serializersModule_1 = serializersModule;
        $this.resultIndex_1 = resultIndex;
        $this.inline_1 = inline;
        $this.output_1 = null;
        return $this;
      }
      get_serializersModule_piitvg_k$() {
        return this.serializersModule_1;
      }
      beginStructure_yljocp_k$(descriptor) {
        return MinEncoderSI2().new_com_lightningkite_services_database_MinEncoderSI2_1ub143_k$(this, this.serializersModule_1, this.resultIndex_1);
      }
      encodeValue_g68i1f_k$(value) {
        this.output_1 = value;
      }
      encodeSerializableValue_3uuzip_k$(serializer, value) {
        if (this.inline_1)
          this.output_1 = value;
        else {
          serializer.serialize_5ase3y_k$(this, value);
        }
      }
      encodeNull_ejiosz_k$() {
        this.output_1 = null;
      }
      endStructure_1xqz0n_k$(descriptor) {
      }
    }
    initMetadataForClass($, 'MinEncoderSI');
    MinEncoderSIClass = $;
  }
  return MinEncoderSIClass;
}
var MinDecoderBClass;
function MinDecoderB() {
  if (MinDecoderBClass === VOID) {
    class $ extends AbstractDecoder() {
      constructor(serializersModule, items) {
        super();
        this.serializersModule_1 = serializersModule;
        this.items_1 = items;
        this.elementIndex_1 = 0;
      }
      get_serializersModule_piitvg_k$() {
        return this.serializersModule_1;
      }
      decodeNotNullMark_us4ba1_k$() {
        return !(this.items_1.get_c1px32_k$(this.elementIndex_1) == null);
      }
      decodeNull_jzrmuj_k$() {
        this.elementIndex_1 = this.elementIndex_1 + 1 | 0;
        return null;
      }
      decode_m3924y_k$() {
        var tmp = this.items_1;
        var _unary__edvuaz = this.elementIndex_1;
        this.elementIndex_1 = _unary__edvuaz + 1 | 0;
        return tmp.get_c1px32_k$(_unary__edvuaz);
      }
      decodeValue_jl9esj_k$() {
        return ensureNotNull(this.decode_m3924y_k$());
      }
      decodeSerializableValue_xpnpad_k$(deserializer) {
        return this.decode_m3924y_k$();
      }
      decodeSequentially_xlblqy_k$() {
        return true;
      }
      decodeElementIndex_bstkhp_k$(descriptor) {
        if (this.elementIndex_1 >= this.items_1.get_size_woubt6_k$())
          return -1;
        return this.elementIndex_1;
      }
      beginStructure_yljocp_k$(descriptor) {
        var tmp0_subject = descriptor.get_kind_wop7ml_k$();
        var tmp;
        if (equals(tmp0_subject, CLASS_getInstance()) || equals(tmp0_subject, OBJECT_getInstance())) {
          var tmp_0 = this.decode_m3924y_k$();
          tmp = new (MinDecoderB())(this.serializersModule_1, (!(tmp_0 == null) ? isInterface(tmp_0, KtList()) : false) ? tmp_0 : THROW_CCE());
        } else if (equals(tmp0_subject, MAP_getInstance())) {
          tmp = new (MinDecoder())(this.serializersModule_1, this.decode_m3924y_k$());
        } else if (equals(tmp0_subject, LIST_getInstance())) {
          tmp = new (MinDecoder())(this.serializersModule_1, this.decode_m3924y_k$());
        } else {
          // Inline function 'kotlin.TODO' call
          throw NotImplementedError().new_kotlin_NotImplementedError_8rzvsv_k$();
        }
        return tmp;
      }
    }
    initMetadataForClass($, 'MinDecoderB');
    MinDecoderBClass = $;
  }
  return MinDecoderBClass;
}
var MinEncoderSI2Class;
function MinEncoderSI2() {
  if (MinEncoderSI2Class === VOID) {
    class $ extends AbstractEncoder() {
      constructor(parent, serializersModule, resultIndex) {
        return new.target.new_com_lightningkite_services_database_MinEncoderSI2_1ub143_k$(parent, serializersModule, resultIndex);
      }
      static new_com_lightningkite_services_database_MinEncoderSI2_1ub143_k$(parent, serializersModule, resultIndex) {
        var $this = this.new_kotlinx_serialization_encoding_AbstractEncoder_2d7vxe_k$();
        $this.parent_1 = parent;
        $this.serializersModule_1 = serializersModule;
        $this.resultIndex_1 = resultIndex;
        $this.stack_1 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(4);
        $this.reallyEncode_1 = true;
        return $this;
      }
      get_serializersModule_piitvg_k$() {
        return this.serializersModule_1;
      }
      encodeElement_5v7eyb_k$(descriptor, index) {
        // Inline function 'kotlin.also' call
        var this_0 = index === this.resultIndex_1;
        this.reallyEncode_1 = this_0;
        return this_0;
      }
      encodeValue_g68i1f_k$(value) {
        if (this.reallyEncode_1) {
          var tmp0_safe_receiver = lastOrNull(this.stack_1);
          if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.add_utx5q5_k$(value)) == null) {
            // Inline function 'kotlin.run' call
            this.parent_1.output_1 = value;
          }
        }
      }
      encodeSerializableValue_3uuzip_k$(serializer, value) {
        if (value == null) {
          this.encodeNull_ejiosz_k$();
        } else {
          this.encodeValue_g68i1f_k$(!(value == null) ? value : THROW_CCE());
        }
      }
      beginStructure_yljocp_k$(descriptor) {
        this.stack_1.add_utx5q5_k$(ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(descriptor.get_elementsCount_288r0x_k$()));
        return NoopEncoder_getInstance();
      }
      endStructure_1xqz0n_k$(descriptor) {
        var tmp0_safe_receiver = removeLastOrNull(this.stack_1);
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          this.encodeValue_g68i1f_k$(tmp0_safe_receiver);
        }
      }
      encodeNull_ejiosz_k$() {
        var value = null;
        if (this.reallyEncode_1) {
          var tmp0_safe_receiver = lastOrNull(this.stack_1);
          if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.add_utx5q5_k$(value)) == null) {
            // Inline function 'kotlin.run' call
            this.parent_1.output_1 = value;
          }
        }
      }
    }
    initMetadataForClass($, 'MinEncoderSI2');
    MinEncoderSI2Class = $;
  }
  return MinEncoderSI2Class;
}
var NoopEncoderClass;
function NoopEncoder() {
  if (NoopEncoderClass === VOID) {
    class $ extends AbstractEncoder() {
      constructor() {
        return new.target.new_com_lightningkite_services_database_NoopEncoder_7lzlu4_k$();
      }
      static new_com_lightningkite_services_database_NoopEncoder_7lzlu4_k$() {
        NoopEncoder_instance = null;
        var $this = this.new_kotlinx_serialization_encoding_AbstractEncoder_2d7vxe_k$();
        NoopEncoder_instance = $this;
        $this.serializersModule_1 = EmptySerializersModule();
        return $this;
      }
      get_serializersModule_piitvg_k$() {
        return this.serializersModule_1;
      }
      encodeNull_ejiosz_k$() {
      }
      encodeValue_g68i1f_k$(value) {
      }
      encodeNotNullMark_415a1t_k$() {
      }
      encodeSerializableValue_3uuzip_k$(serializer, value) {
      }
      beginStructure_yljocp_k$(descriptor) {
        return this;
      }
      endStructure_1xqz0n_k$(descriptor) {
      }
    }
    initMetadataForObject($, 'NoopEncoder');
    NoopEncoderClass = $;
  }
  return NoopEncoderClass;
}
var NoopEncoder_instance;
function NoopEncoder_getInstance() {
  if (NoopEncoder_instance === VOID)
    NoopEncoder().new_com_lightningkite_services_database_NoopEncoder_7lzlu4_k$();
  return NoopEncoder_instance;
}
var properties_initialized_kxSerializationFieldAccess_kt_jhpvst;
function _init_properties_kxSerializationFieldAccess_kt__gdcurf() {
  if (!properties_initialized_kxSerializationFieldAccess_kt_jhpvst) {
    properties_initialized_kxSerializationFieldAccess_kt_jhpvst = true;
    empty = EmptySerializersModule();
  }
}
//region block: exports
export {
  get as get3797f9mle0itg,
  set as set2ew7jrhm4kojs,
};
//endregion

//# sourceMappingURL=kxSerializationFieldAccess.mjs.map
